(function () {
    'use strict';

    a3_cabin_reports.factory('GroundDutyFactory', GroundDutyFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name GroundDutyFactory
    * @description 
    * Add, Update and Get Ground Duties.
    * @ngInject
    */
    function GroundDutyFactory(GenericService, $http, apiUrl) {

        /**
        * Initialize the GroundDuty
        * @memberof GroundDutyFactory
        */
        function GroundDuty() {
            this.Id = null;
            this.Duty = null;
            this.DutyDescription = null;
            this.DutyBegin = null;
            this.DutyEnd = null;
            this.GetId = GetId;
            this.isTraining = false;
            this.icon = null;
            this.Instructors = new Array();
            this.Trainees = new Array();
            this.isManualEntry = false;
            this.hasPendingCourse = false;
        }

        var objType = 'groundDuty';
        var objCallback = GroundDuty;

        var service = {
            getGroundDutiesFromStorage: getGroundDutiesFromStorage,
            setGroundDutiesToStorage: setGroundDutiesToStorage,
            getGroundDutyFromStorage: getGroundDutyFromStorage,
            getGroundDutyActiveCourses: getGroundDutyActiveCourses,
            getGroundDutiesByDutyNo: getGroundDutiesByDutyNo,
            mergeGroundDutyInfo: mergeGroundDutyInfo,
            updateGroundDuty: updateGroundDuty,
            setCourseCompleted: setCourseCompleted,
            setCoursePending: setCoursePending,
            isLastDay: isLastDay,
            mergeGroundDutiesToStorage: mergeGroundDutiesToStorage,
            refresh: refresh,
            addGroundDuty: addGroundDuty,
            removeGroundDuty: removeGroundDuty,
            getManualGroundDutiesFromStorage: getManualGroundDutiesFromStorage,
            getFirstAndLastDateOfGroundDuties: getFirstAndLastDateOfGroundDuties
        };

        /**
         * Overide default get Id
         * @memberof GroundDutyFactory
         * @returns {number} Id 
         */
        function GetId() {
            return this.Id;
        }

        /**
         * Get Ground Duties.
         * @memberof GroundDutyFactory
         * @returns {Array} GroundDuties 
         */
        function getGroundDutiesFromStorage() {
            return GenericService.list(objType, objCallback);
        }
        /**
         * Get GroundDuty from storage groundDuties
         * @memberof GroundDutyFactory
         * @param {number} groundDutyId 
         * @return {object} groundDuty
         */
        function getGroundDutyFromStorage(groundDutyId) {
            var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
            var instructors = [];
            var trainees = [];

            if (groundDuty != null && groundDuty != undefined) {
                //only training
                if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
                    groundDuty.isTraining = true;

                    groundDuty.RelatedGroundDuties.forEach(function (element) {
                        if (element.IsInstructor) {
                            instructors.push(element);
                        }
                        else {
                            trainees.push(element);
                        }
                    });

                    groundDuty.Trainees = trainees;
                    groundDuty.Instructors = instructors;
                }
            }
            return groundDuty;
        }
        /**
         * Save Ground Duties to storage
         * @memberof GroundDutyFactory
         * @param {Array} GroundDuties A list of Ground Duties
         */
        function setGroundDutiesToStorage(objList) {
            GenericService.saveAll(objList, objType);
        }

        /**Save Ground Duties to storage but keep local storage values
         * Necessary to maintain Absent values in training duties
         */
        function mergeGroundDutiesToStorage(objList, fromSync) {
            var groundDuties = getGroundDutiesFromStorage();

            if(!fromSync) {
                groundDuties.filter(x => x.isManualEntry).forEach(function (duty) {
                    objList.push(duty);
                });     
            }
           
            if (groundDuties) {
                objList.forEach(function (incomingDuty) {

                    if (incomingDuty.RelatedGroundDuties) {
                        var incomingTraineesFlat = [];
                        incomingDuty.RelatedGroundDuties.filter(x => !x.IsInstructor).forEach(function (related) {
                            related.CrewMembers.forEach(function (trainee) {
                                incomingTraineesFlat.push(trainee);
                            });
                        });

                        //Initialize all as present
                        incomingTraineesFlat.forEach(function (incomingTrainee) {
                            incomingTrainee.Absent = false;
                        });

                        //Copy Absent value from existing local storage duties
                        var existingDuty = groundDuties.find(x => x.Id == incomingDuty.Id);
                        if (existingDuty && existingDuty.RelatedGroundDuties) {
                            var existingTraineesFlat = [];
                            existingDuty.RelatedGroundDuties.filter(x => !x.IsInstructor).forEach(function (related) {
                                related.CrewMembers.forEach(function (trainee) {
                                    existingTraineesFlat.push(trainee);
                                });
                            });

                            incomingTraineesFlat.forEach(function (incomingTrainee) {
                                var existingTrainee = existingTraineesFlat.find(x => x.Id == incomingTrainee.Id);
                                if (existingTrainee) {
                                    incomingTrainee.Absent = existingTrainee.Absent;
                                }
                            });
                        }

                    }

                });
            }
            GenericService.saveAll(objList, objType);
        }

        /**
         * Get GroundDuties of a Crew Route
         * @memberof GroundDutyFactory 
         * @param {number} dutyNo 
         * @param {string} dutyDay
         * @return {array} groundDuties
         */
        function getGroundDutiesByDutyNo(dutyNo, dutyDay) {
            var groundDuties = getGroundDutiesFromStorage();
            if (groundDuties == null)
                return [];
            var result = [];

            var instructors = [];
            var trainees = [];

            var arrayLength = groundDuties.length;
            for (var i = 0; i < arrayLength; i++) {
                if (groundDuties[i].DutyNo == dutyNo && groundDuties[i].DutyDay == dutyDay) {
                    //only training
                    if (groundDuties[i].RelatedGroundDuties && groundDuties[i].RelatedGroundDuties.length > 1) {
                        groundDuties[i].isTraining = true;

                        instructors = [];
                        trainees = [];

                        groundDuties[i].RelatedGroundDuties.forEach(function (element) {
                            if (element.IsInstructor) {
                                instructors.push(element);
                            }
                            else {
                                trainees.push(element);
                            }
                        });

                        groundDuties[i].Trainees = trainees;
                        groundDuties[i].Instructors = instructors;
                    }

                    result.push(groundDuties[i]);
                }
            }


            return result;
        }

        /**
         * Merge new info to current Ground Duty
         * @memberof GroundDutyFactory
         * @param {object} duty 
         */
        function mergeGroundDutyInfo(duty) {
            var currentGroundDutyInfo = GenericService.get(duty.Id, objType, objCallback);
            currentGroundDutyInfo.Code = duty.Code;
            currentGroundDutyInfo.Description = duty.Description;
            currentGroundDutyInfo.DutyDate = duty.DutyDate;
            currentGroundDutyInfo.GroundDutyNo = duty.GroundDutyNo;
            currentGroundDutyInfo.DutyDateS = duty.DutyDateS;
            currentGroundDutyInfo.DutyBegin = duty.DutyBegin;
            currentGroundDutyInfo.DutyEnd = duty.DutyEnd;
            currentGroundDutyInfo.DutyDay = duty.DutyDay;
            currentGroundDutyInfo.DutyNo = duty.DutyNo;
            currentGroundDutyInfo.Route = duty.Route;

            if (currentGroundDutyInfo.RelatedGroundDuties && currentGroundDutyInfo.RelatedGroundDuties.length) {
                currentGroundDutyInfo.RelatedGroundDuties = duty.RelatedGroundDuties;
            }
            GenericService.save(currentGroundDutyInfo, objType, objCallback);
        }

        /**
         * Check in calendar if this is the last day of this duty
         * @param {object} groundDuty 
         */
        function isLastDay(groundDuty, course) {
            //Get duty's Trainee codes
            var traineeCodes = [... new Set(groundDuty.RelatedGroundDuties.filter(x => x.Courses && x.Courses.find(y => y.CourseId == course.Id))
                .map(r => r.Code))];

            //Get Remaining Trainee codes
            var remainingTraineeCodes = [];
            var remainingGroundDuties = GenericService.list(objType, objCallback)    //get all grounDuties
                .filter(x => x.RelatedGroundDuties &&
                    x.RelatedGroundDuties.length > 1 &&                     //filter only training
                    dateDifference(groundDuty.DutyBegin, x.DutyBegin) < 0); //check later duty date

            remainingGroundDuties.forEach(function (groundDuty) {
                var codes = groundDuty.RelatedGroundDuties.filter(x => !x.IsInstructor).map(y => y.Code);   //only trainee codes
                remainingTraineeCodes = remainingTraineeCodes.concat(codes);
            });

            remainingTraineeCodes = [...new Set(remainingTraineeCodes)];            //remove duplicates

            return !remainingTraineeCodes.some(r => traineeCodes.includes(r));
        }

        /**
         * Compares two dates
         * @param {date} currentDate 
         * @param {date} checkDate 
         */
        function dateDifference(currentDate, checkDate) {
            var currentDate = moment(currentDate);
            var checkDate = moment(checkDate);
            return currentDate.diff(checkDate)
        }

        function updateGroundDuty(groundDuty) {
            GenericService.save(groundDuty, objType, objCallback);
        }


        function addGroundDuty(groundDuty) {
            var storedGroundDuty = GenericService.get(groundDuty.Id, objType, objCallback);
            if (!storedGroundDuty) {
                GenericService.add(groundDuty, objType, objCallback);
            }
            else {
                updateGroundDuty(groundDuty);
            }
        }

        function removeGroundDuty(groundDuty) {
            GenericService.remove(groundDuty, objType, objCallback);
        }

        function setCourseCompleted(dutyId, courseId) {
            var groundDuty = GenericService.get(dutyId, objType, objCallback);
            groundDuty.RelatedGroundDuties.filter(x => x.Courses).forEach(function (item) {
                var groundDutyCourse = item.Courses.find(x => x.CourseId == courseId);
                if (groundDutyCourse) {
                    groundDutyCourse.Status = "Completed";
                }
            });

            var allCoursesAreCompleted = false;

            if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
                allCoursesAreCompleted = groundDuty.RelatedGroundDuties.filter(x => x.Courses && x.Courses.length > 0).every(function (relatedDuty) {
                    return relatedDuty.Courses.every(function (course) {
                        return course.Status == "Completed";
                    });
                });
            }

            if (groundDuty.isManualEntry && allCoursesAreCompleted) {
                groundDuty.hasPendingCourse = false;
            }
            updateGroundDuty(groundDuty);
        }

        function setCoursePending(dutyId, courseId) {
            var groundDuty = GenericService.get(dutyId, objType, objCallback);
            groundDuty.RelatedGroundDuties.filter(x => x.Courses).forEach(function (item) {
                var groundDutyCourse = item.Courses.find(x => x.CourseId == courseId);
                if (groundDutyCourse) groundDutyCourse.Status = "Pending";
            });
            updateGroundDuty(groundDuty);
        }

        function getGroundDutyActiveCourses(groundDutyId) {
            var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
            var courses = [];
            if (groundDuty != null && groundDuty != undefined) {
                if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
                    groundDuty.RelatedGroundDuties.filter(x => !x.IsInstructor && x.Courses).forEach(function (item) {
                        courses.push(...item.Courses);
                    });
                }
            }
            return courses;
        }

        function refresh(refreshGroundDuty, callback) {
            return $http.post(apiUrl + '/GroundDuty/Refresh', refreshGroundDuty, { 'Content-Type': 'application/json' })
                .then(callback);
        }

        /**Get manual Ground Duties from storage*/
        function getManualGroundDutiesFromStorage() {
            var groundDuties = getGroundDutiesFromStorage();
            return groundDuties.filter(x => x.isManualEntry);
        }

        function getFirstAndLastDateOfGroundDuties(){
            var groundDuties = getGroundDutiesFromStorage();

			const parseDate = dateString => new Date(dateString);

			let firstDutyDate = null;
			let lastDutyDate = null;

			for (const obj of groundDuties) {
				const currentDate = parseDate(obj.DutyDate);

				if (!firstDutyDate || currentDate < firstDutyDate) {
					firstDutyDate = currentDate;
				}

				if (!lastDutyDate || currentDate > lastDutyDate) {
					lastDutyDate = currentDate;
				}
			}
			return {firstDate: firstDutyDate, lastDate: lastDutyDate };

        }

        return service;
    }

})();